import store from '@/store'

if(localStorage.lt) {
  store.dispatch("user/fetchPermissions").then(res=>{
    if(res) {
      store.commit("status/setReady", true);
    }else {
      store.commit("status/setReady", true);
      // localStorage.removeItem("lt");
      // location.reload();
    }
  });
}else {
  store.commit("status/setReady", true);
}
console.log("middleware");